import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import UserProfile from "./UserProfile";
import LogoutConfirmation from "./LogoutConfirmation";
import { useNavigate } from "react-router-dom";
import "./TopBar.css";

const TopBar = () => {
  const { user, logout } = useAuth();
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const navigate = useNavigate();

  const handleUserProfileClick = () => {
    setShowUserProfile(true);
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLogoutConfirmation(true);
  };

  const handleLogoutConfirm = () => {
    logout();
    setShowLogoutConfirmation(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirmation(false);
  };

  const handleCloseUserProfile = () => {
    setShowUserProfile(false);
  };

  return (
    <>
      <div className="top-bar">
        <div className="top-bar-left">
          <div className="logo">
            <img
              src="https://mediquestevents.in/wp-content/uploads/2023/06/mediquest_logo_322x65.png"
              alt="MediQuest Logo"
              style={{ height: 40 }}
            />
          </div>
        </div>

        <div className="top-bar-right">
          <button
            className="top-bar-btn user-profile-btn"
            onClick={handleUserProfileClick}
          >
            <span className="user-icon">👤</span>
            User Profile
          </button>

          {user?.role === "admin" && (
            <a
              className="top-bar-btn users-btn"
              href="/users"
              target="_blank"
              rel="noopener noreferrer"
              style={{ margin: "0 12px", textDecoration: "none" }}
            >
              <span className="users-icon">👥</span>
              Users
            </a>
          )}

          <button
            className="top-bar-btn logout-btn"
            onClick={handleLogoutClick}
          >
            <span className="logout-icon">🚪</span>
            Logout
          </button>
        </div>
      </div>

      {/* User Profile Modal */}
      {showUserProfile && (
        <UserProfile user={user} onClose={handleCloseUserProfile} />
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutConfirmation && (
        <LogoutConfirmation
          onConfirm={handleLogoutConfirm}
          onCancel={handleLogoutCancel}
        />
      )}
    </>
  );
};

export default TopBar;
